const NewsletterModal = ({ closeNewsModal, isNewsModalOpen }) => {
  const Modal = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;

    return (
      <div className="modal-overlay DATENSCHUTZ Impressum">
        <div
          className="modal"
          style={{ display: "block", marginTop: "200px", width: "50%" }}
        >
          {children}
        </div>
      </div>
    );
  };

  return (
    <>
      <Modal isOpen={isNewsModalOpen} onClose={closeNewsModal}>
        <div className="modal_head">
          {" "}
          <button className="close-btn" onClick={closeNewsModal}>
            Schließen
          </button>
        </div>
        <iframe
          src="https://technikkenner.ssl.mailausdemnorden.de/f/251410-248225/"
          title="Newsletter"
          style={{ width: "100%", height: "900px", border: "none" }}
        ></iframe>
      </Modal>
    </>
  );
};

export default NewsletterModal;
